import { render, staticRenderFns } from "./HotelRoomTypeKey.vue?vue&type=template&id=034354d5&"
import script from "./HotelRoomTypeKey.vue?vue&type=script&lang=js&"
export * from "./HotelRoomTypeKey.vue?vue&type=script&lang=js&"
import style0 from "./HotelRoomTypeKey.vue?vue&type=style&index=0&id=034354d5&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034354d5')) {
      api.createRecord('034354d5', component.options)
    } else {
      api.reload('034354d5', component.options)
    }
    module.hot.accept("./HotelRoomTypeKey.vue?vue&type=template&id=034354d5&", function () {
      api.rerender('034354d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/HotelRoomTypeKey.vue"
export default component.exports